import { render, staticRenderFns } from "./GenerateFormItem.vue?vue&type=template&id=361b039f&scoped=true&"
import script from "./GenerateFormItem.vue?vue&type=script&lang=js&"
export * from "./GenerateFormItem.vue?vue&type=script&lang=js&"
import style0 from "./GenerateFormItem.vue?vue&type=style&index=0&id=361b039f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361b039f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('361b039f')) {
      api.createRecord('361b039f', component.options)
    } else {
      api.reload('361b039f', component.options)
    }
    module.hot.accept("./GenerateFormItem.vue?vue&type=template&id=361b039f&scoped=true&", function () {
      api.rerender('361b039f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/GenerateForm/GenerateFormItem.vue"
export default component.exports